import React, { useContext } from 'react';
import { MessageType } from '../../core/localization';
import { LocaleCtx } from '../../contexts/locale.context';
import SpinnerBase, { SpinnerBaseProps } from './spinnerBase';

interface Props extends SpinnerBaseProps {
  label?: MessageType;
}
const Spinner: React.FC<Props> = (props) => {
  const { translate } = useContext(LocaleCtx);
  const label = props.label ? translate(props.label) : undefined;
  return <SpinnerBase {...{ ...props, label }} />;
};

export default Spinner;
